import { SelectEventMessage } from "flavr-common";
import { PickupGrabbableMessage, ReleaseGrabbableMessage, MoveGrabbableMessage, ModelClickedMessage, RemoteModelClickedMessage } from "@messages/interaction/InteractionMessages";
import { ScriptRPCMessage, ScriptRPCOnlyHostMessage } from "@messages/scripting/ScriptMessages";
import { peerService } from "./PeerService";
export class PeerImmediatelyMessageHandler {
    constructor(connection, peerMgr) {
        this.peerMgr = peerMgr;
        this.handleMessage = (msg) => {
            this.peerMgr.broadcastBusMessage(msg);
        };
        this.handleModelClickedMessage = (msg) => {
            // ToDo: send direct to Host?
            this.peerMgr.broadcastBusMessage(new RemoteModelClickedMessage(msg.uid, msg.hitPoint));
        };
        this.handleScriptRPCMessage = (msg) => {
            this.peerMgr.broadcastBusMessage(msg);
        };
        this.handleScriptRPCOnlyHostMessage = (msg) => {
            this.peerMgr.sendToBusMessage(peerService.hostClientId, msg);
        };
        connection.subscribeByType(SelectEventMessage, this.handleMessage);
        connection.subscribeByType(ModelClickedMessage, this.handleModelClickedMessage);
        connection.subscribeByType(PickupGrabbableMessage, this.handleMessage);
        connection.subscribeByType(ReleaseGrabbableMessage, this.handleMessage);
        connection.subscribeByType(MoveGrabbableMessage, this.handleMessage);
        connection.subscribeByType(ScriptRPCMessage, this.handleScriptRPCMessage);
        connection.subscribeByType(ScriptRPCOnlyHostMessage, this.handleScriptRPCOnlyHostMessage);
    }
}
